import type { TabItem } from '../../types/lists';

interface Props {
  tabs: TabItem[];
  value: string;
  onChange: (id: string) => void;
  ariaLabel?: string;
  className?: string;
}

export function TabStrip({ tabs, value, onChange, ariaLabel, className = '' }: Props) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={`flex items-center gap-1 border-b border-slate-200 overflow-x-auto -mx-1 px-1 ${className}`}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === value;
        const toneCount =
          tab.tone === 'warn'
            ? 'text-amber-600'
            : isActive
            ? 'text-[#00A871]'
            : 'text-slate-400';
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={`shrink-0 px-3 py-2 text-[13px] cursor-pointer border-b-2 -mb-px transition-colors ${
              isActive
                ? 'border-[#00A871] text-slate-900 font-medium'
                : 'border-transparent text-slate-500 hover:text-slate-900'
            }`}
          >
            {tab.label}
            {tab.count != null && (
              <span className={`ml-1.5 text-[11px] tabular-nums font-mono-num ${toneCount}`}>
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
